import React from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

const P4Footer = (props) => {
  return (
    <MDBFooter className="font-small pt-4 mt-4">
      <MDBContainer fluid className="text-center text-md-left" style={props.style}>
        <MDBRow>
          <MDBCol md="6">
            <h5 className="title">株式会社P4NEXT</h5>
            <address>
              埼玉県さいたま市浦和区仲町1-14-8<br />
              大樹生命浦和ビル6階<br />
              <a href="https://p4next.co.jp/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit" }}>https://p4next.co.jp/</a>
            </address>
          </MDBCol>
          <MDBCol md="6">
            <ul>
              <li className="list-unstyled">
                <a href="#!">サイトポリシー</a>
              </li>
              <li className="list-unstyled">
                <a href="#!">ご利用規約</a>
              </li>
              <li className="list-unstyled">
                <a href="#!">個人情報保護方針</a>
              </li>
              <li className="list-unstyled">
                <a href="#!">サポート</a>
              </li>
              <li className="list-unstyled d-flex align-items-center justify-content-center justify-content-md-start mt-2">
                <span className="mr-1" style={{ fontSize: "14px", color: "inherit" }}>Search by</span>
                <img src="https://cloud.typesense.org/packs/static/images/favicon-cb82a5737af933df690b.png" alt="Typesense" style={{ height: "20px", verticalAlign: "middle" }} className="mr-1" />
                <span style={{ fontWeight: "bold", fontSize: "14px" }}>Typesense</span>
              </li>
            </ul>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <div className="footer-copyright text-center py-3" style={props.style2}>
        <MDBContainer fluid>
          &copy; {new Date().getFullYear()} Copyright: <a href="https://p4next.co.jp/"> P4NEXT </a>
        </MDBContainer>
      </div>
    </MDBFooter>
  );
}

export default P4Footer;